var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-icon-logo 1",
    clipPath: "url(#clip0_65_6025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7141 13.0176C23.7141 12.0344 23.6343 11.3168 23.4616 10.5728H12.2336V15.0107H18.8242C18.6914 16.1136 17.9739 17.7746 16.3793 18.8907L16.357 19.0393L19.907 21.7895L20.153 21.814C22.4118 19.7278 23.7141 16.6584 23.7141 13.0176Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2335 24.7103C15.4623 24.7103 18.173 23.6472 20.1529 21.8136L16.3792 18.8903C15.3693 19.5945 14.014 20.0862 12.2335 20.0862C9.07109 20.0862 6.38703 18.0001 5.43023 15.1167L5.28999 15.1286L1.59857 17.9854L1.55029 18.1196C3.51683 22.0261 7.55625 24.7103 12.2335 24.7103Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.43041 15.1168C5.17796 14.3727 5.03185 13.5754 5.03185 12.7516C5.03185 11.9277 5.17796 11.1305 5.41713 10.3864L5.41044 10.2279L1.67277 7.3252L1.55047 7.38336C0.739971 9.00446 0.274902 10.8249 0.274902 12.7516C0.274902 14.6783 0.739971 16.4986 1.55047 18.1197L5.43041 15.1168Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.2335 5.417C14.4791 5.417 15.9938 6.38698 16.8575 7.19758L20.2326 3.90225C18.1598 1.97556 15.4623 0.792969 12.2335 0.792969C7.55625 0.792969 3.51683 3.47703 1.55029 7.38353L5.41695 10.3866C6.38703 7.50317 9.07109 5.417 12.2335 5.417Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_6025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.792969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.251f3b7d6a879fc097c098672ee355e1.svg";
export { ForwardRef as ReactComponent };